/**
 * ### FILE MUST NOT BE CHANGED WITHOUT QA TEAM APPROVAL
 *
 * - XPath objects must be made taking into account code-splitting and such that
 *    xpath of code-splitted module is loaded only when that module is required.
 * - Prefer to use **aria-label, title, text and mui data-testid(svg-icon)**, but
 *    **IF** there is conflict as multiple icons appears on screen and all above attribute fails
 *    in that case we can add your own scope based data-testid as tie-breaker solution.
 * - XPath for popover/context menu using popover mui component can be assigned to popover itself.
 * - Don't add xpath on list of items, example a list item inside dropdown can be selected
 *    by maintaining a order[] in script itself.
 * - Don't add it on any item that doesn't have any CTA associated with it.
 */

interface XPathProps {
  'data-testid'?: string;
  /**
   * data-region are useful if a space has to be identified and not CTA item.
   */
  'data-region'?: string;
}

export const ResearchTabXPath = {
  Root: {
    'data-testid': 'research_tab/root',
  },
  Search: {
    'data-testid': 'research_tab/search',
  },
  Card: {
    'data-testid': 'research_tab/result_card',
  },
  CardInfoView: {
    'data-testid': 'research_tab/result_card_info_view',
  },
  BookmarkButton: {
    'data-testid': 'research_tab/result_card/bookmark_button',
  },
  MoreOptions: {
    'data-testid': 'research_tab/result_card/more_options',
  },
  CloseInfoViewButton: {
    'data-testid': 'research_tab/result_card_info_view/close_button',
  },
};

export const BookmarkTabXPath = {
  Root: {
    'data-testid': 'bookmark_tab/root',
  },
  Anchor: {
    'data-testid': 'bookmark_tab/anchor',
  },
  Card: {
    'data-testid': 'bookmark_tab/result_card',
  },
  CardInfoView: {
    'data-testid': 'bookmark_tab/result_card_info_view',
  },
  BookmarkButton: {
    'data-testid': 'bookmark_tab/result_card/bookmark_button',
  },
  MoreOptions: {
    'data-testid': 'bookmark_tab/result_card/more_options',
  },
  CloseInfoViewButton: {
    'data-testid': 'bookmark_tab/result_card_info_view/close_button',
  },
};

export const NotebookTabXPath = {
  IdeaEditor: {
    'data-testid': 'tool_pane/notebook_tab/idea_editor',
  },
};

export const ContextMenuXPath = {
  Root: {
    'data-testid': 'context_menu/root',
  },
};

export const ListPageXPath = {
  RecentViewSection: {
    'data-testid': 'list_page/recent_view_section',
  },
  TemplateViewSection: {
    'data-testid': 'list_page/template_view_section',
  },
  TrashViewSection: {
    'data-testid': 'list_page/trash_view_section',
  },
  RecentProjectsInListView: {
    'data-testid': 'list_page/list-view',
  },
  RecentProjectsInGridView: {
    'data-testid': 'list_page/grid-view',
  },
  ProjectCard: {
    'data-testid': 'list_page/project_card',
  },
  TemplateCard: {
    'data-testid': 'list_page/template_card',
  },
  TrashProjectCard: {
    'data-testid': 'list_page/trash_project_card',
  },
};

export const PageHeaderXPath = {
  Root: {
    'data-testid': 'page_header/root',
  },
  Logo: {
    'data-testid': 'page_header/logo',
  },
  Title: {
    'data-testid': 'page_header/title',
  },
};

export const BottomBarXPath = {
  Root: {
    'data-testid': 'bottom_bar/root',
  },
  ParaphraseButton: {
    'data-testid': 'bottom_bar/paraphrase_button',
  },
  SummarizeButton: {
    'data-testid': 'bottom_bar/summarize_button',
  },
  SuggestTextButton: {
    'data-testid': 'bottom_bar/suggest_text_button',
  },
  StatsButton: {
    'data-testid': 'bottom_bar/stats_button',
  },
  StatsOptions: {
    'data-testid': 'bottom_bar/stats_options',
  },
  ErrorButton: {
    'data-testid': 'bottom_bar/error_button',
  },
  ErrorOptions: {
    'data-testid': 'bottom_bar/error_options',
  },
  DictateButton: {
    'data-testid': 'bottom_bar/dictate_button',
  },
};

export const PageEditorXPath = {
  Editor: {
    'data-testid': 'page_editor/editor',
  },
  BibPage: {
    'data-testid': 'page_editor/bib_page',
  },
  SuggestionRoot: {
    'data-testid': 'page_editor/suggestion_root',
  },
};

export const SidebarXPath = {
  Root: {},
  CollapsedSidebar: {},
  ExpandedSidebar: {},
};
